import { initialListPaginationMeta } from "utils/helpers/pagination";

import {
  AddOrderDropDownState,
  AddOrderForm,
  AddOrderModalContext,
  AddOrderModalState,
} from "../types";

export const initialAddOrderForm: AddOrderForm = {
  vehicleImage: "",
  vehicleImageName: "",
  customerName: "",
  subCustomer: "",
  chassis: "",
  manufacturer: "",
  model: "",
  axleConfiguration: "",
  year: "",
  boxType: "",
};

export const initialDropDownState: AddOrderDropDownState = {
  items: [],
  page: 1,
  perPage: 20,
  meta: initialListPaginationMeta,
  loading: false,
  error: null,
};

export const initialState: AddOrderModalState = {
  isOpen: false,
  context: AddOrderModalContext.QUOTE,
  form: initialAddOrderForm,
  dropDowns: {
    customers: { ...initialDropDownState },
    manufacturers: { ...initialDropDownState },
    models: { ...initialDropDownState },
  },
};
